import { useSetPageMeta } from '../../../hooks/usePageMeta';
import GrowthOpsOverview from './GrowthOpsOverview';
import ProviderCampaignTable from './ProviderCampaignTable';

export default function GrowthOpsPage() {
  useSetPageMeta({
    title: 'Growth Ops',
    description: 'Monitor and manage Growth tier advertising operations',
  });

  return (
    <div className="space-y-6">
      <GrowthOpsOverview />
      <ProviderCampaignTable />
    </div>
  );
}
